import React, { useState, useEffect } from "react";

const MissionVision = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [animatedCards, setAnimatedCards] = useState([]);

  useEffect(() => {
    // Trigger initial animation
    const timer = setTimeout(() => setIsVisible(true), 100);

    // Animate mission points with staggered delay
    const animateCards = () => {
      missionPoints.forEach((_, index) => {
        setTimeout(
          () => {
            setAnimatedCards((prev) => [...prev, index]);
          },
          800 + index * 150,
        );
      });
    };

    const cardsTimer = setTimeout(animateCards, 600);

    return () => {
      clearTimeout(timer);
      clearTimeout(cardsTimer);
    };
  }, []);

  const missionPoints = [
    "Developing participants into various skills in line with present and future requirements of the Tanzania labour market",
    "Producing modern day professionals with high skills of entrepreneurship and professionalism to see Tanzania through challenge of the 21st century",
    "Providing equal learning opportunity to the under priviledge and the have nots of the society",
    "Providing a second chance to unsuccessful standard seven and form four leavers to clear their grades while simultaneously continues to acquire technical skills",
  ];

  const VisionIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  );

  const MottoIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M14,17H7L2,12L7,7H14V10.5H22V13.5H14V17Z" />
    </svg>
  );

  const MissionIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,17L7,12L8.41,10.59L12,14.17L15.59,10.59L17,12L12,17Z" />
    </svg>
  );

  const CheckIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
    </svg>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-8 px-4 relative overflow-hidden">
      <div className="container mx-auto max-w-7xl">
        {/* Header with entrance animation */}
        <div
          className={`text-center mb-12 transition-all duration-1000 ease-out ${
            isVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 -translate-y-10"
          }`}
        >
          <h1 className="font-extrabold text-custom-pink mb-4 tracking-tight text-4xl sm:text-5xl md:text-6xl hover:scale-105 transition-transform duration-300">
            Mission & Vision
          </h1>
          <div
            className={`w-24 h-1 bg-gradient-to-r from-gold to-gold mx-auto rounded-full transition-all duration-1000 delay-300 ${
              isVisible ? "scale-x-100" : "scale-x-0"
            }`}
          ></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Vision Card with slide-in animation */}
          <div
            className={`shadow-2xl border-2 border-white/30 relative overflow-hidden rounded-3xl backdrop-blur-xl transition-all duration-800 delay-200 ease-out hover:scale-105 hover:shadow-3xl hover:-translate-y-2 group ${
              isVisible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-20"
            }`}
            style={{
              background: "rgba(255, 255, 255, 0.25)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-custom-pink-100/20 to-purple-100/20 opacity-100 group-hover:from-custom-pink-200/30 group-hover:to-purple-200/30 transition-all duration-300"></div>
            <div className="p-8 md:p-10 relative z-10">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-gradient-to-br from-gold to-gold rounded-xl mr-4 shadow-lg transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300">
                  <VisionIcon className="w-8 h-8 md:w-10 md:h-10 text-black" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-custom-pink group-hover:text-custom-pink-700 transition-colors duration-300">
                  JR's Vision
                </h2>
              </div>
              <p className="text-lg md:text-xl leading-relaxed text-black font-medium group-hover:text-gray-800 transition-colors duration-300">
                Training youths who are unable to pursue advanced secondary
                education acquire appropriate quality technical skills through
                holistic development
              </p>
            </div>
          </div>

          {/* Motto Card with slide-in animation */}
          <div
            className={`shadow-2xl border-2 border-white/30 relative overflow-hidden rounded-3xl backdrop-blur-xl transition-all duration-800 delay-300 ease-out hover:scale-105 hover:shadow-3xl hover:-translate-y-2 group ${
              isVisible
                ? "opacity-100 translate-x-0"
                : "opacity-0 translate-x-20"
            }`}
            style={{
              background: "rgba(255, 255, 255, 0.25)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-gold/20 to-custom-pink-100/20 opacity-100 group-hover:from-gold-500/30 group-hover:to-custom-pink-200/30 transition-all duration-300"></div>
            <div className="p-8 md:p-10 relative z-10">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-gradient-to-br from-gold to-gold rounded-xl mr-4 shadow-lg transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300">
                  <MottoIcon className="w-8 h-8 md:w-10 md:h-10 text-black" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-custom-pink group-hover:text-custom-pink-700 transition-colors duration-300">
                  Motto Statement
                </h2>
              </div>
              <p className="text-lg md:text-xl leading-relaxed text-black font-medium group-hover:text-gray-800 transition-colors duration-300">
                Bridging the gap of education by creating opportunities through
                Business Development
              </p>
            </div>
          </div>
        </div>

        {/* Mission Section with fade-up animation */}
        <div
          className={`bg-white/70 backdrop-blur-sm border border-white/20 rounded-3xl overflow-hidden shadow-2xl transition-all duration-1000 delay-400 ease-out hover:shadow-3xl hover:bg-white/80 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
          }`}
        >
          <div className="bg-gradient-to-r from-gold to-gold p-1">
            <div className="bg-white rounded-3xl">
              <div className="p-8 md:p-12">
                <div className="flex items-center justify-center mb-8 group">
                  <div className="p-4 bg-gradient-to-br from-gold to-gold rounded-2xl mr-4 shadow-lg group-hover:rotate-3 group-hover:scale-110 transition-all duration-300">
                    <MissionIcon className="w-10 h-10 md:w-12 md:h-12 text-black" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-custom-pink group-hover:text-custom-pink-700 transition-colors duration-300">
                    Mission Statement
                  </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {missionPoints.map((point, index) => (
                    <div
                      key={index}
                      className={`flex items-start space-x-4 p-6 rounded-2xl bg-gradient-to-r from-gold/10 to-custom-pink-50 shadow-md border border-gold/50 transition-all duration-500 hover:scale-105 hover:shadow-lg hover:bg-gradient-to-r hover:from-gold/20 hover:to-custom-pink-100 group cursor-pointer ${
                        animatedCards.includes(index)
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-5"
                      }`}
                    >
                      <div className="flex-shrink-0 mt-1">
                        <div className="w-8 h-8 bg-gradient-to-br from-gold to-gold rounded-full flex items-center justify-center scale-110 group-hover:scale-125 group-hover:rotate-12 transition-all duration-300">
                          <CheckIcon className="w-4 h-4 text-black" />
                        </div>
                      </div>
                      <p className="text-gray-900 leading-relaxed text-sm md:text-base group-hover:text-gray-700 transition-colors duration-300">
                        {point}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Bottom accent with staggered animation */}
                <div className="mt-8 pt-8 border-t border-gray-200">
                  <div className="flex flex-wrap justify-center gap-3">
                    {[
                      "Skills Development",
                      "Entrepreneurship",
                      "Equal Opportunity",
                      "Second Chances",
                    ].map((tag, index) => (
                      <span
                        key={index}
                        className={`px-4 py-2 bg-gradient-to-r from-gold/20 to-custom-pink/20 text-custom-pink rounded-full font-semibold shadow-md text-sm md:text-base transition-all duration-500 hover:scale-110 hover:shadow-lg hover:bg-gradient-to-r hover:from-gold/30 hover:to-custom-pink/30 cursor-default ${
                          isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-3"
                        }`}
                        style={{
                          animationDelay: `${1200 + index * 100}ms`,
                          transitionDelay: `${1200 + index * 100}ms`,
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Decorative Elements with movement */}
        <div className="fixed top-20 left-10 w-32 h-32 bg-gradient-to-br from-custom-pink-200/30 to-purple-200/30 rounded-full blur-3xl animate-pulse pointer-events-none opacity-60"></div>
        <div
          className="fixed bottom-20 right-10 w-24 h-24 bg-gradient-to-br from-gold/30 to-custom-pink-200/30 rounded-full blur-2xl animate-pulse pointer-events-none opacity-60"
          style={{ animationDelay: "1000ms" }}
        ></div>

        {/* Additional floating elements */}
        <div
          className="fixed top-1/2 left-5 w-16 h-16 bg-gradient-to-br from-blue-200/20 to-indigo-200/20 rounded-full blur-xl animate-bounce pointer-events-none opacity-40"
          style={{ animationDuration: "3s", animationDelay: "2000ms" }}
        ></div>
        <div
          className="fixed top-1/3 right-5 w-20 h-20 bg-gradient-to-br from-purple-200/20 to-custom-pink-200/20 rounded-full blur-2xl animate-bounce pointer-events-none opacity-40"
          style={{ animationDuration: "4s", animationDelay: "500ms" }}
        ></div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .hover\\:shadow-3xl:hover {
          box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.25);
        }
      `}</style>
    </div>
  );
};

export default MissionVision;
